
import { ref, defineComponent, defineAsyncComponent } from 'vue'
import { useI18n } from 'vue-i18n'

export default defineComponent({
  components: {
    zh: defineAsyncComponent(() => import('@/components/agreements/zh.vue')),
    en: defineAsyncComponent(() => import('@/components/agreements/en.vue'))
  },
  setup() {
    const { locale } = useI18n()
    const current = ref(locale.value)
    const goBack = () => {
      history.go(-1)
    }
    return {
      current,
      goBack,
    }
  },
})
